import { Box, Flex, Text } from "@chakra-ui/react";
import React from "react";

interface ClaimItemHeaderProps {
  section: string;
  items: number;
}

function ClaimItemHeader({ section, items }: ClaimItemHeaderProps) {
  return (
    <Box>
      <Flex mt="32px" mb="12px" fontSize="12px" fontWeight="400">
        <Box flex="1">
          <Text fontSize="12" color="gray.500">
            Amount
          </Text>
        </Box>
        <Box flex="1">
          <Text
            fontSize="12"
            color="gray.500"
            textAlign="right"
            mr={items > 3 ? "10px" : "0px"}
          >
            Exchange rate
          </Text>
        </Box>
        <Box flex="2">
          <Text
            fontSize="12"
            color="gray.500"
            textAlign="right"
            mr={items > 3 ? "30px" : "0px"}
          >
            {section === "completed" ? "Withdrew on" : ""}
          </Text>
        </Box>
      </Flex>
    </Box>
  );
}

export default ClaimItemHeader;
